import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast'
import { useToast } from '@/components/ui/use-toast'

export function Toaster() {
  const { toasts } = useToast()

  const defaultToasts = toasts.filter((t) => t.position !== 'top-right')
  const topRightToasts = toasts.filter((t) => t.position === 'top-right')

  return (
    <>
      <ToastProvider>
        {defaultToasts.map(function ({
          id,
          title,
          description,
          action,
          ...props
        }) {
          return (
            <Toast key={id} {...props}>
              <div className='grid gap-1'>
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
              {action}
              <ToastClose />
            </Toast>
          )
        })}
        <ToastViewport />
      </ToastProvider>
      <ToastProvider>
        {topRightToasts.map(function ({
          id,
          title,
          description,
          action,
          ...props
        }) {
          return (
            <Toast key={id} {...props}>
              <div className='grid gap-1'>
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
              {action}
              <ToastClose />
            </Toast>
          )
        })}
        {/* The base viewport pins itself to the bottom from `sm` up
            (`sm:bottom-0 sm:top-auto`). Those are responsive variants, so
            tailwind-merge keeps them alongside an unprefixed `top-4` and they
            win on any screen ≥640px — the sm-prefixed overrides below are what
            actually move this viewport to the top. */}
        <ToastViewport className='fixed right-4 top-4 z-[100] flex max-h-screen w-full flex-col gap-2 p-0 sm:bottom-auto sm:right-4 sm:top-4 md:max-w-[420px]' />
      </ToastProvider>
    </>
  )
}
